import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }
const _hoisted_4 = { class: "ml30" }

import Pagination from '@/components/Pagination.vue'
import { useStore } from '@/store'
import { getCurrentInstance, reactive, onMounted, ref, watch } from 'vue'
import Keys from '@/constant/key'
import { getBindApplyListApi, getSmsSignListApi, checkBindApplyApi, saveBindApplyApi, getBindApplyDetailApi, delBindApplyApi, extractBindCodeApi } from '@/apis/channel'
import { getDingtalkUserListApi, sendCodeWithoutPhone } from '@/apis/zone'
import SelectSaleChannel from '@/components/SelectSaleChannel.vue'
import { maskPhone } from '@/utils/index'

enum CheckStatus {
    '审核中',
    '已同意并发码',
    '已驳回',
    '提交失败',
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BindCoupon',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const uploadRef = ref()
const groupString = store.state.user.userInfo.group_id
const groupArray = groupString.split(',')

// 申请审核状态
const filters = reactive({
    sale_channel:       '',     // 销售渠道名称
    audit_status:       '',     // 审核状态：0-待审核，1-已通过，2-已驳回
    submit_time:        '',     // 提交时间
    audit_time:         '',     // 审核时间
    page:               1,      // 当前页码
    page_size:          10,     // 每页显示条数
})

const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const { code, data, msg } = await getBindApplyListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
}

// 获取签名列表
const signList = ref<any[]>([])
const getSignList = async () => {
    if (signList.value.length) return
    const { code, data, msg } = await getSmsSignListApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    signList.value = data
}

// 获取宜搭用户列表
const dingtalkUserList = ref<any[]>([])
const getDingtalkUserList = async () => {
    const { code, data, msg } = await getDingtalkUserListApi() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    dingtalkUserList.value = data
}

// 获取完整渠道数据，用saler匹配销售审核人
const handleChannelSelect = async (channelItem: any) => {
    await getDingtalkUserList()
    if (channelItem && channelItem.saler) {
        const saler = channelItem.saler
        const matchedUser = dingtalkUserList.value.find(item => item.name === saler)
        if (matchedUser) {
            formData.value.yd_user = matchedUser.yd_user
        } else {
            formData.value.yd_user = ''
        }
    }
}

onMounted(() => {
    getList()
    getSignList()
    getDingtalkUserList()
})

/*******************************  提交申请 -- begin ********************************/
const batchAddDialog = ref(false) // 提交弹窗
const batchErrorMsg = ref('') // 提交失败提示
const formData = ref<any>({
    file: '',
    sale_channel: '',
    yd_user: '',
    issue_method: 1, // 发码方式：1-发短信，0-不发短信
    content: '',
    sms_sign: ''
})

const inForm = ref()
const rules = reactive({
    sale_channel: [{ required: true, message: '请选择销售渠道', trigger: 'change' }],
    yd_user: [{ required: true, message: '请选择销售审批人', trigger: 'change' }],
    issue_method: [{ required: true, message: '请选择发码方式', trigger: 'change' }],
    sms_sign: [{
        validator: (rule, value, callback) => {
            if (formData.value.issue_method === 1 && !value) {
                callback(new Error('请选择签名'))
            } else {
                callback()
            }
        },
        trigger: 'change'
    }],
    // 短信内容必须包含 #1 占位符
    content: [{
        validator: (rule, value, callback) => {
            if (formData.value.issue_method === 1 && !value) {
                callback(new Error('请输入短信内容'))
            } else if (formData.value.issue_method === 1 && !value.includes('#1')) {
                callback(new Error('短信内容必须包含 #1 占位符'))
            } else {
                callback()
            }
        },
        trigger: 'blur'
    }]
})

// 签名选择时，自动添加到短信内容中
watch(() => formData.value.sms_sign, (newVal, oldVal) => {
    if (newVal) {
        let content = formData.value.content || ''
        if (oldVal && content.startsWith(oldVal)) {
            content = content.substring(oldVal.length)
        }
        if (!content.startsWith(newVal)) {
            formData.value.content = newVal + content
        }
    }
})
// 监听内容变化，确保签名不被删除
watch(() => formData.value.content, (newVal, oldVal) => {
    if (formData.value.issue_method === 1 && formData.value.sms_sign) {
        if (!newVal.startsWith(formData.value.sms_sign)) {
            // 如果签名被修改或删除，强制恢复签名，保留后续内容
            const sign = formData.value.sms_sign
            
            // 如果 newVal 长度小于签名长度，说明用户删除了签名的部分内容
            if (newVal.length < sign.length) {
                if (oldVal && oldVal.startsWith(sign)) {
                    const oldRest = oldVal.substring(sign.length)
                    formData.value.content = sign + oldRest
                } else {
                    // 如果 oldVal 也不合法（初始状态等），直接强制前缀
                    formData.value.content = sign
                }
            } else {
                if (oldVal && oldVal.startsWith(sign)) {
                     formData.value.content = sign + newVal.replace(sign, '') // 简单替换掉可能存在的签名防止重复
                } else {
                    formData.value.content = sign + newVal
                }
            }
        }
    }
})
const fileList = ref([]) // 上传文件列表
const onFileChange = (file, fileList) => {
    formData.value.file = file.raw
}
const onFileRemove = (file, fileList) => {
    formData.value.file = null
}
const onFileExceed = () => {
    proxy.$message({ type: 'error', message: '只能上传一个文件，请删除后重新上传' })
}

const onSubmit= async (isChecked = false) => {
    if (!inForm.value) return
    await inForm.value.validate(async (valid) => {
        if (valid) {
            if (!formData.value.file) return proxy.$message({ type: 'error', message: '请上传文件' })

            if (isChecked) {
                const { code, data, msg } = await saveBindApplyApi(formData.value) as any
                if (code == 200) {
                    proxy.$message({ type: 'success', message: '添加成功' })
                    getList()
                    beforeAddDialogClosed()
                } else {
                    proxy.$message({ type: 'error', message: msg })
                    batchErrorMsg.value = msg
                }
            } else {
                const { code, data, msg } = await checkBindApplyApi(formData.value) as any
                if (code == 200) {
                    onSubmit(true)
                } else {
                    const { normal_error, repeat_days_error } = data
                    if (normal_error.length) {
                        proxy.$message({ type: 'error', message: `数据校验失败：${normal_error.join('；')}` })
                        batchErrorMsg.value = msg
                    } else if (repeat_days_error.length) {
                        proxy.$confirm(`30天内出现重复的手机号${repeat_days_error.length}个。<p style="color:#F56C6C;">注：如工会需求找销售核对；如兑换需求请到兑换平台核对</p>`, '提示', {
                            type: 'warning',
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '确认继续',
                            cancelButtonText: '去核对关闭',
                        }).then(() => {
                            onSubmit(true)
                        }).catch(() => {
                            console.log('取消操作')
                        })
                    } else {
                        proxy.$message({ type: 'error', message: msg })
                        batchErrorMsg.value = msg
                    }
                }
            }
        }
    })
}
const beforeAddDialogClosed = () => {
    batchErrorMsg.value = ''
    if(uploadRef.value) {
        uploadRef.value!.clearFiles()
    }
    if (inForm.value) {
        inForm.value.resetFields()
    }
    formData.value.file = null
    batchAddDialog.value = false
    getList()
}
/*******************************  提交申请 -- end ********************************/

/*******************************  提取 -- begin ********************************/
const extractDialog = ref(false)
const extractFormData = ref<any>({
    batch_id: '',
    phone: maskPhone(store.state.user.userInfo.phone) || '',
    code: ''
})
const openExtractDialog = (row) => {
    extractFormData.value.batch_id = row.batch_id
    extractFormData.value.phone = maskPhone(store.state.user.userInfo.phone),
    extractDialog.value = true
}
const beforeExtractDialogClosed = () => {
    extractFormData.value = {
        batch_id: '',
        code: ''
    }
    extractDialog.value = false
}
// 发送验证码
const onSend = async () => {
    if (!extractFormData.value.phone) return proxy.$message({ type: 'error', message: '当前登录账号未绑定手机号，无法提取' })
    const { code, data, msg } = await sendCodeWithoutPhone() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    doCountDown() // 开始倒计时
}
const second = ref<number>(0) // 倒计时
// 倒计时
const doCountDown = () => {
    second.value = 60
    const timer = setInterval(() => {
        second.value > 0 ? second.value-- : clearInterval(timer)
    }, 1000)
}
const onExtract = async () => {
    const { code, data, msg } = await extractBindCodeApi(extractFormData.value) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    
    window.open(data)
    beforeExtractDialogClosed()
    getList()
}
/*******************************  提取 -- end ********************************/

/*******************************  查看 -- begin ********************************/
const viewDialog = ref(false)
const viewData = ref<any>([])
const viewSaleChannel = ref('')
const viewSaleName = ref('')
const getViewData = async (batch_id) => {
    const { code, data, msg } = await getBindApplyDetailApi(batch_id) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    viewData.value = data.face_value_stat
    viewSaleChannel.value = data.sale_channel
    viewSaleName.value = data.sale_name
}
const onView = (row) => {
    getViewData(row.batch_id)
    viewDialog.value = true
}
/*******************************  查看 -- end ********************************/

// 删除
const onDel = (row) => {
    proxy.$confirm('删除不可恢复, 确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(async () => {
        const { code, msg } = await delBindApplyApi(row.batch_id) as any
        if (code != 200) return proxy.$message({ type: 'error', message: msg })
        proxy.$message({ type: 'success', message: '删除成功' })
        getList()
    })
}

// 导出
const onExport = (row) => {
    if(row == 1) {
        const params = new URLSearchParams({
            export_type: 'all',
            Access_token: store.state.user.userInfo.access_token
        })
        // 过滤值为空字符串的参数
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== '' && value !== null && value !== undefined && key !== 'page' && key !== 'page_size') {
                params.append(key, String(value))
            }
        })
        window.open(`${Keys.baseUrl}/couponBatch/couponBatchUnionExport?${params.toString()}`)
    }
    else {
        window.open(`${Keys.baseUrl}/couponBatch/couponBatchUnionExport?batch_id=${row.batch_id}&Access_token=${store.state.user.userInfo.access_token}`)
    }
}

// 重新提交
const onReSubmit = (row) => {
    proxy.$message({ type: 'warning', message: '请联系技术人员解决~' })
}

const onSearch = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectSaleChannel, {
        class: "filter-item",
        modelValue: filters.sale_channel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.sale_channel) = $event)),
        clearable: "",
        placeholder: "销售渠道"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        filterable: "",
        modelValue: filters.audit_status,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.audit_status) = $event)),
        placeholder: "审核状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "待审核",
            value: "0"
          }),
          _createVNode(_component_el_option, {
            label: "通过",
            value: "1"
          }),
          _createVNode(_component_el_option, {
            label: "驳回",
            value: "2"
          }),
          _createVNode(_component_el_option, {
            label: "提交失败",
            value: "3"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.submit_time,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.submit_time) = $event)),
        placeholder: "提交时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.audit_time,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.audit_time) = $event)),
        placeholder: "审核时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (onSearch()))
      }, {
        default: _withCtx(() => _cache[20] || (_cache[20] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (batchAddDialog.value = true))
      }, {
        default: _withCtx(() => _cache[21] || (_cache[21] = [
          _createTextVNode("添加上传")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (onExport(1)))
      }, {
        default: _withCtx(() => _cache[22] || (_cache[22] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "sale_channel",
          label: "渠道"
        }),
        _createVNode(_component_el_table_column, { label: "面额" }, {
          default: _withCtx(({ row }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.amount_info, (item) => {
              return (_openBlock(), _createBlock(_component_el_row, {
                key: item.amout
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(`${item.amount}元，${item.quantity}张`), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "total_quantity",
          label: "总数量"
        }),
        _createVNode(_component_el_table_column, { label: "发码方式" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.issue_method == 1 ? '发短信' : '不发短信'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "内容",
          width: "150"
        }, {
          default: _withCtx(({ row }) => [
            (row.issue_method == 1)
              ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.content), 1)
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_el_row, {
                  key: 1,
                  class: "color-danger"
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode("审核通过后，在列表中提取")
                  ])),
                  _: 1
                }))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "submit_time",
          label: "提交时间",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "applicant",
          label: "申请人"
        }),
        _createVNode(_component_el_table_column, { label: "审核状态" }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(CheckStatus[row.audit_status]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "audit_time",
          label: "审核时间",
          width: "145"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "185",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_3, [
              (CheckStatus[row.audit_status] == '已同意并发码')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (onView(row))
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode("查看")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (CheckStatus[row.audit_status] == '已驳回')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (onDel(row))
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode("删除")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (CheckStatus[row.audit_status] == '已同意并发码')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 2,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (onExport(row))
                  }, {
                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                      _createTextVNode("导出")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (CheckStatus[row.audit_status] == '已同意并发码' && row.issue_method == 0)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 3,
                    type: "primary",
                    size: "small",
                    disabled: !row.can_extract,
                    title: !row.can_extract ? '非本人申请无法提取' : '',
                    onClick: ($event: any) => (openExtractDialog(row))
                  }, {
                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                      _createTextVNode(" 提取 ")
                    ])),
                    _: 2
                  }, 1032, ["disabled", "title", "onClick"]))
                : _createCommentVNode("", true),
              (CheckStatus[row.audit_status] == '重新提交')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 4,
                    type: "primary",
                    size: "small",
                    onClick: ($event: any) => (onReSubmit(row)),
                    title: "请联系技术人员解决~"
                  }, {
                    default: _withCtx(() => _cache[28] || (_cache[28] = [
                      _createTextVNode("重新提交")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(_component_el_dialog, {
      title: "发码申请",
      modelValue: batchAddDialog.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((batchAddDialog).value = $event)),
      "before-close": beforeAddDialogClosed
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: beforeAddDialogClosed }, {
          default: _withCtx(() => _cache[35] || (_cache[35] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (onSubmit()))
        }, {
          default: _withCtx(() => _cache[36] || (_cache[36] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "inForm",
          ref: inForm,
          model: formData.value,
          rules: rules,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { class: "content-baseline" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "upload-demo",
                  ref_key: "uploadRef",
                  ref: uploadRef,
                  action: "none",
                  "on-exceed": onFileExceed,
                  "on-change": onFileChange,
                  "on-remove": onFileRemove,
                  "file-list": fileList.value,
                  accept: ".xls,.xlsx",
                  limit: 1,
                  "auto-upload": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small"
                    }, {
                      default: _withCtx(() => _cache[29] || (_cache[29] = [
                        _createTextVNode("上传发码信息")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"]),
                _createVNode(_component_el_link, {
                  class: "ml10",
                  type: "primary",
                  href: `${_unref(Keys).baseUrl}/couponBatch/downLoadExcel?Access_token=${_unref(store).state.user.userInfo.access_token}`
                }, {
                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                    _createTextVNode("下载模版")
                  ])),
                  _: 1
                }, 8, ["href"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "选择渠道",
              prop: "sale_channel"
            }, {
              default: _withCtx(() => [
                _createVNode(SelectSaleChannel, {
                  modelValue: formData.value.sale_channel,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.sale_channel) = $event)),
                  placeholder: "请选择销售渠道",
                  onSelectItem: handleChannelSelect
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "是否发送短信",
              prop: "issue_method"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formData.value.issue_method,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.issue_method) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createTextVNode("是")
                      ])),
                      _: 1
                    }),
                    (!_unref(groupArray).includes('20'))
                      ? (_openBlock(), _createBlock(_component_el_radio, {
                          key: 0,
                          label: 0
                        }, {
                          default: _withCtx(() => _cache[32] || (_cache[32] = [
                            _createTextVNode("否")
                          ])),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (formData.value.issue_method == 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "选择签名",
                  prop: "sms_sign",
                  required: formData.value.issue_method == 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: formData.value.sms_sign,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.sms_sign) = $event)),
                      filterable: "",
                      placeholder: "请选择签名"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(signList.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.sms_sign,
                            value: item.sms_sign
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["required"]))
              : _createCommentVNode("", true),
            (formData.value.issue_method == 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "短信内容",
                  class: "content-end",
                  prop: "content",
                  required: formData.value.issue_method == 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: formData.value.content,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.content) = $event)),
                      placeholder: "请输入短信内容",
                      type: "textarea",
                      rows: 6,
                      maxlength: 200,
                      "show-word-limit": ""
                    }, null, 8, ["modelValue"]),
                    _cache[33] || (_cache[33] = _createElementVNode("span", { style: {"margin-left":"10px","color":"#F56C6C"} }, "#1：代表密码", -1))
                  ]),
                  _: 1
                }, 8, ["required"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "销售审批人",
              prop: "yd_user"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.yd_user,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.yd_user) = $event)),
                  filterable: "",
                  placeholder: "请选择销售审批人",
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dingtalkUserList.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.yd_user,
                        label: item.name,
                        value: item.yd_user
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _cache[34] || (_cache[34] = _createElementVNode("div", { style: {"color":"#F56C6C","font-size":"12px","margin-top":"4px"} }, "注：必填销售负责人，在宜搭完善折扣等信息", -1))
              ]),
              _: 1
            }),
            (batchErrorMsg.value)
              ? (_openBlock(), _createBlock(_component_el_form_item, { key: 2 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_alert, {
                      title: batchErrorMsg.value,
                      type: "error",
                      closable: false
                    }, null, 8, ["title"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "提取券码",
      modelValue: extractDialog.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((extractDialog).value = $event)),
      "before-close": beforeExtractDialogClosed
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          disabled: !extractFormData.value.code,
          onClick: onExtract
        }, {
          default: _withCtx(() => _cache[37] || (_cache[37] = [
            _createTextVNode("确定")
          ])),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "dialogForm",
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "当前绑定手机号",
              prop: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: extractFormData.value.phone,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((extractFormData.value.phone) = $event)),
                  modelModifiers: { trim: true },
                  disabled: "",
                  style: {"width":"200px","margin-right":"10px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "验证码",
              prop: "code"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: extractFormData.value.code,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((extractFormData.value.code) = $event)),
                      modelModifiers: { trim: true },
                      placeholder: "输入验证码",
                      maxlength: "4",
                      onInput: _cache[16] || (_cache[16] = ($event: any) => (extractFormData.value.code = extractFormData.value.code.replace(/[^0-9]/g,''))),
                      style: {"width":"200px","margin-right":"10px"}
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_el_button, {
                      type: "danger",
                      disabled: second.value > 0,
                      onClick: onSend
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(second.value > 0 ? second.value : '获取验证码'), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "",
      modelValue: viewDialog.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((viewDialog).value = $event)),
      width: "85%"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (viewDialog.value = false))
        }, {
          default: _withCtx(() => _cache[39] || (_cache[39] = [
            _createTextVNode("关闭")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, { class: "bold font20" }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, "销售渠道：" + _toDisplayString(viewSaleChannel.value), 1),
            _createElementVNode("span", _hoisted_4, "销售名称：" + _toDisplayString(viewSaleName.value), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table, {
          data: viewData.value,
          stripe: "",
          border: "",
          class: "mt20"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "面值（元）",
              prop: "amount"
            }),
            _createVNode(_component_el_table_column, {
              label: "结算面值",
              prop: "clearing_price"
            }),
            _createVNode(_component_el_table_column, {
              label: "折扣",
              prop: "coupon_discount"
            }),
            _createVNode(_component_el_table_column, {
              label: "小计",
              prop: "amount"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString((parseFloat(row.amount) * row.total_num).toFixed(2)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "批次总数量",
              prop: "total_num"
            }),
            _createVNode(_component_el_table_column, {
              label: "发码方式",
              prop: "amount"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.issue_method == 1 ? '发短信' : '系统提取'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "内容" }, {
              default: _withCtx(({ row }) => [
                (row.issue_method == 1)
                  ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.content), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : (_openBlock(), _createBlock(_component_el_row, {
                      key: 1,
                      class: "color-danger"
                    }, {
                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                        _createTextVNode("审核通过后，在列表中提取")
                      ])),
                      _: 1
                    }))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "发送状态" }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(row.send_status == 0 ? '未发送' : (row.send_status == 1 ? '已发送' : '发送失败')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "卡券类型",
              prop: "card_type"
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})